// =============================================================================
// App
// =============================================================================
// Vendor Scripts
// =============================================================================
// Nothing to import

// Global
// =============================================================================
import Body from './global/body';
import './global/hash-scroll';
import './global/race-space-skip';

// Partials
// =============================================================================
import SiteHeader from './partials/site-header';

// Menus
// =============================================================================
import HeaderMenu from './menus/header-menu';
import FooterMenu from './menus/footer-menu';

// Components
//= ============================================================================
import './components/notification-banner';
import './components/gallery';
import './components/popup';
import './components/tabs';
// import './components/tabs-two';
import './components/instagram-feed';
import './components/countdown';
import './components/image-text';

import HeroSlides from './components/hero';
import Testimonials from './components/testimonials';
import Accordion from './components/accordion';
import SlideBoxes from './components/slide-boxes';
import SlideBoxesTwo from './components/slide-boxes-two';
import CardSlides from './components/card-slides';

import EventArchive from './components/event-archive';
import EventList from './components/event-list';
import EventElevation from './components/event-elevation';
import Archive from './components/archive';

import GoogleMap from './objects/google-map';

// Events
import SlideItinerary from './components/itinerary';
import SlideTestimonials from './components/events-testimonials';
import EventCards from './components/event-cards';
import './components/table';

// Boilerplate Components
//= ============================================================================

// Functions
// =============================================================================
import Animations from './functions/animations';

// Vendor
import 'lity/src/lity.js';

$(function () {
	// Global
	const body = new Body();

	// Functions
	const animations = new Animations();

	// Menus
	const headerMenu = new HeaderMenu();
	const footerMenu = new FooterMenu();

	// Components
	const heroSlides = new HeroSlides();
	const testimonials = new Testimonials();
	const accordion = new Accordion();
	const slideBoxes = new SlideBoxes();
	const slideBoxesTwo = new SlideBoxesTwo();
	const cardSlides = new CardSlides();

	const googleMap = new GoogleMap();
	const eventArchive = new EventArchive();
	const eventList = new EventList();
	const eventElevation = new EventElevation();
	const archive = new Archive();

	// Events
	const slideItinerary = new SlideItinerary();
	const slideTestimonials = new SlideTestimonials();
	const eventCards = new EventCards();

	// Partials
	const siteHeader = new SiteHeader();

	function initApp() {
		body.init();
		animations.init();

		siteHeader.init();
		headerMenu.init();
		footerMenu.init();

		heroSlides.init();
		testimonials.init();
		slideBoxes.init();
		slideBoxesTwo.init();
		cardSlides.init();
		accordion.init();

		slideItinerary.init();
		slideTestimonials.init();
		eventCards.init();

		googleMap.init();
		eventArchive.init();
		eventList.init();
		eventElevation.init();
		archive.init();
	}

	initApp();
});